
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import FactoryIcon from '@mui/icons-material/Factory';
import InventoryIcon from '@mui/icons-material/Inventory';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import AddTaskIcon from '@mui/icons-material/AddTask';

const Sales = {
  id: '4',
  title: 'Order Mgmt',
  type: 'group',
  role: 'PHARMA_OMS_SALES',
  children: [
    {
      id: 'pharmaorder',
      title: 'Order List',
      type: 'item',
      url: '/',
      bottomMenu:'ORDERS',
      icon: ShoppingBagIcon
    },
    {
      id: 'party',
      title: 'Party Mgmt',
      type: 'item',
      url: '/',
      bottomMenu:'PARTY',
      icon: ContactEmergencyIcon
    },
    // {
    //         id: 'orderapproval',
    //         title: 'Order Approval',
    //         type: 'item',
    //         url: '/',
    //         bottomMenu:'ORDER_APPROVAL',
    //         icon: AddTaskIcon
    //       },
  ]
};

export default Sales;